import {
  Box,
  Button,
  IconButton,
  TextField,
  Grid,
  Stack,
  Typography,
  MenuItem,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { vehicleCategoriesActions } from "../../service/vehicleCategories.actions";
import "../vehicleCategories/vehicleCategories.css";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useEffect, useState } from "react";
import { useHasScope } from "../../../../config/globalConfig";
import { carCompanyActions } from "../../service/carCompany.actios";

const VehicleCategoriesModal: any = (props: any) => {
  const hasScope = useHasScope;
  const closeModal = props.closeModal;
  const carCompanyAction = carCompanyActions();
  const initaliaValueVehicle = props.initaliaValueVehicle;
  const [countClick, setCountClick] = useState<number>(0);
  const [acrissType, setAcrissType] = useState<any>([]);
  const [editVehicle, setEditVehicle] = useState<any>({
    customAcrissLabel: initaliaValueVehicle?.customAcrissLabel,
    acrissVehicleType: initaliaValueVehicle?.acrissVehicleType,
    acrissLabel: initaliaValueVehicle?.acrissLabel,
    customAcrissKeyless: initaliaValueVehicle?.customAcrissKeyless,
    customAcrissAdditionalCreditCard:
      initaliaValueVehicle?.customAcrissAdditionalCreditCard === undefined
        ? ""
        : initaliaValueVehicle?.customAcrissAdditionalCreditCard,
    acrissMaxOverbooking: initaliaValueVehicle?.acrissMaxOverbooking,
    customAcrissAdditionalCreditCardTotal:
      initaliaValueVehicle?.customAcrissAdditionalCreditCardTotal,
  });

  const { t } = useTranslation(["operation"]);
  const re = /^[0-9\b]+$/;
  const handleChange = (event: any, type: any) => {
    console.log(event, "event.target.value");
    setEditVehicle({ ...editVehicle, [type]: event.target.value });
  };
  const cancel = () => {
    closeModal(false);
  };
  const disabledSipAdditionalFielsd = () => {
    return editVehicle?.customAcrissAdditionalCreditCard?.toString() === "true"
      ? false
      : true;
  };
  const changeNameAcrissKeyless = (params: String) => {
    switch (params) {
      case "true":
        return t("internOptionSelectName.yes");
      case "false":
        return t("internOptionSelectName.no");
      default:
        return "";
    }
  };
  const editVehicleCategories = () => {
    setCountClick(1);
    if (countClick === 1) {
      const editVehicleObject = {
        customAcrissId: initaliaValueVehicle.customAcrissID,
        acrissId: initaliaValueVehicle.acrissID,
        acrissLabel: editVehicle.acrissLabel,
        acrissVehicleType: editVehicle.acrissVehicleType,
        acrissMaxOverbooking: editVehicle.acrissMaxOverbooking,
        customAcrissLabel: editVehicle.customAcrissLabel,
        customAcrissAdditionalCreditCard:
          editVehicle?.customAcrissAdditionalCreditCard,
        customAcrissAdditionalCreditCardTotal:
          editVehicle.customAcrissAdditionalCreditCardTotal,
        // customAcrissKeyless: editVehicle.customAcrissKeyless,
      };

      props.onUpdateVehicle(editVehicleObject);
    }
  };

  useEffect(() => {
    carCompanyAction
      .acrissVehicleType()
      .then((response) => setAcrissType(response));
  }, []);

  return (
    <Box className="dialogClass">
      <Dialog
        PaperProps={{
          sx: {
            maxWidth: "1161px",
            minHeight: "357px",
          },
        }}
        open={true}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
      >
        <DialogTitle
          className="dialogTitleClass"
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          <Grid
            container
            alignItems="center"
            alignContent="center"
            direction="row"
          >
            <Grid xs item>
              {t("vehicleCategory.editAction.title")}
            </Grid>
            <Grid xs item sx={{ justifyContent: "flex-end", display: "flex" }}>
              <IconButton className="cancelIconClass">
                <CloseIcon onClick={cancel} />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <Box>
            <Grid
              container
              alignItems="center"
              alignContent="center"
              mr={0}
              direction="row"
              spacing={2.5}
            >
              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label={t("vehicleCategory.editAction.carSegmentEdit")}
                    disabled
                    // placeholder={t(
                    //   "vehicleCategory.searchAndFilter.carSegmentOrder"
                    // )}
                    multiline
                    className="TextField"
                    variant="standard"
                    value={initaliaValueVehicle.carSegmentOrder}
                  />
                </Box>
              </Grid>
              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label={t("availabilityReport.carSegmentLabel")}
                    disabled
                    // placeholder={t(
                    //   "vehicleCategory.searchAndFilter.carSegment"
                    // )}
                    multiline
                    className="TextField"
                    variant="standard"
                    value={initaliaValueVehicle.carSegmentDescr}
                  />
                </Box>
              </Grid>
              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    className="TextField"
                    id="standard-read-only-input"
                    label={t("vehicleCategory.carClassDescr")}
                    // placeholder={t("vehicleCategory.searchAndFilter.carClass")}
                    multiline
                    disabled
                    variant="standard"
                    value={initaliaValueVehicle.carClassDescr}
                  />
                </Box>
              </Grid>
              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label={t("vehicleCategory.acrissCode")}
                    // placeholder={t("vehicleCategory.searchAndFilter.arciss")}
                    disabled
                    className="TextField"
                    variant="standard"
                    value={initaliaValueVehicle.acrissCode}
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems="center"
              alignContent="center"
              mr={0}
              direction="row"
              spacing={2.5}
            >
              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="acrissLabel"
                    label={t("vehicleCategory.acrissLabel")}
                    // placeholder={t("vehicleCategory.editAction.acrissLabel")}
                    multiline
                    className="TextField"
                    variant="standard"
                    name="acrissLabel"
                    onChange={(event) => handleChange(event, "acrissLabel")}
                    value={editVehicle.acrissLabel}
                  />
                </Box>
              </Grid>
              <Grid xs item>
                <Box>
                  <TextField
                    label={t("vehicleCategory.acrissVehicleType")}
                    fullWidth
                    id="acrissVehicleType"
                    name="acrissVehicleType"
                    // placeholder={t(
                    //   "vehicleCategory.editAction.enterAcrissVehicleType"
                    // )}
                    select
                    value={editVehicle.acrissVehicleType}
                    onChange={(event) =>
                      handleChange(event, "acrissVehicleType")
                    }
                  >
                    {acrissType.map((option: any) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Grid>
              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label={t("vehicleCategory.editAction.acrissMaxOverbooking")}
                    // placeholder={t("vehicleCategory.editAction.acrissMaxOverbooking")}
                    multiline
                    className="TextField"
                    variant="standard"
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "/^-?d+(?:.d+)?$/g",
                    }}
                    value={editVehicle.acrissMaxOverbooking}
                    onChange={(event) => {
                      if (
                        event.target.value === "" ||
                        re.test(event.target.value)
                      ) {
                        handleChange(event, "acrissMaxOverbooking");
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="outlined-required"
                    label={t("vehicleCategory.customAcrissCode")}
                    disabled
                    // placeholder={t("vehicleCategory.searchAndFilter.sipp")}
                    multiline
                    className="TextField"
                    variant="standard"
                    value={initaliaValueVehicle.customAcrissCode}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              alignItems="center"
              alignContent="center"
              mr={0}
              direction="row"
              spacing={2.5}
            >
              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="customAcrissLabel"
                    label={t("vehicleCategory.customAcrissLabel")}
                    disabled={
                      initaliaValueVehicle.customAcrissCode !== ""
                        ? false
                        : true
                    }
                    // placeholder={t("vehicleCategory.editAction.enterSippLabel")}
                    multiline
                    className="TextField"
                    variant="standard"
                    value={editVehicle.customAcrissLabel}
                    onChange={(event) =>
                      handleChange(event, "customAcrissLabel")
                    }
                  />
                </Box>
              </Grid>

              <Grid xs item>
                <Box>
                  <TextField
                    label={t("vehicleCategory.customAcrissKeyless")}
                    fullWidth
                    id="customAcrissKeyless"
                    name="customAcrissKeyless"
                    // placeholder={t(
                    //   "vehicleCategory.editAction.enterSippKeyless"
                    // )}
                    disabled
                    value={changeNameAcrissKeyless(
                      editVehicle.customAcrissKeyless
                    )}
                  ></TextField>
                </Box>
              </Grid>

              <Grid xs item>
                <Box>
                  <TextField
                    label={t(
                      "vehicleCategory.editAction.customAcrissAdditionalCreditCard"
                    )}
                    fullWidth
                    id="customAcrissAdditionalCreditCard"
                    name="customAcrissAdditionalCreditCard"
                    // placeholder={t(
                    //   "vehicleCategory.editAction.customAcrissAdditionalCreditCard"
                    // )}
                    select
                    value={editVehicle.customAcrissAdditionalCreditCard}
                    disabled={
                      initaliaValueVehicle.customAcrissCode !== ""
                        ? false
                        : true
                    }
                    onChange={(event) => {
                      handleChange(event, "customAcrissAdditionalCreditCard");
                    }}
                  >
                    <MenuItem value="true">
                      {t("internOptionSelectName.yes")}
                    </MenuItem>
                    <MenuItem value="false">
                      {t("internOptionSelectName.no")}
                    </MenuItem>
                  </TextField>
                </Box>
              </Grid>
              <Grid xs item>
                <Box>
                  <TextField
                    fullWidth
                    id="customAcrissAdditionalCreditCardTotal"
                    label={t(
                      "vehicleCategory.editAction.customAcrissAdditionalCreditCardTotal"
                    )}
                    // placeholder={t("vehicleCategory.editAction.customAcrissAdditionalCreditCardTotal")}
                    multiline
                    className="TextField"
                    disabled={disabledSipAdditionalFielsd()}
                    variant="standard"
                    value={
                      editVehicle?.customAcrissAdditionalCreditCard.toString() ===
                      "false"
                        ? 0
                        : editVehicle.customAcrissAdditionalCreditCardTotal
                    }
                    onChange={(event) => {
                      if (
                        event.target.value === "" ||
                        re.test(event.target.value)
                      ) {
                        handleChange(
                          event,
                          "customAcrissAdditionalCreditCardTotal"
                        );
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions className="dialogActionsClass">
          <Grid
            container
            alignItems="center"
            alignContent="center"
            direction="row"
          >
            <Grid xs>
              {!!countClick && (
                <Stack direction="row" spacing={1} pl={2}>
                  <ReportProblemIcon className="iconsClassAction" />
                  <Box className="errorMessageAction">
                    <Box>
                      <Typography className="errorMessageTextAction">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t(
                              "vehicleCategory.editAction.warningMessage"
                            ),
                          }}
                        ></div>
                      </Typography>
                    </Box>
                  </Box>
                </Stack>
              )}
            </Grid>

            <Grid
              xs
              item
              sx={{ display: "flex", justifyContent: "flex-end" }}
              pr={2}
            >
              {hasScope("SCOPE_UPDATE_MDVEHICLE_CATEGORIZATION") && (
                <Stack direction="row" spacing={2.5}>
                  <Button
                    variant="outlined"
                    className="canelButtonClass"
                    onClick={cancel}
                  >
                    <span className="canelTextClass">
                      {t("actionButtons.cancel")}
                    </span>
                  </Button>
                  <Button
                    variant="contained"
                    type={"submit"}
                    form="statusForm"
                    className="saveButtonClass"
                    onClick={editVehicleCategories}
                  >
                    <span className="confirnTextClass">
                      {t("actionButtons.save")}
                    </span>
                  </Button>
                </Stack>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default VehicleCategoriesModal;
